import capitalize from 'lodash/capitalize';

export default function (week) {
  const firstDay = week[0],
    lastDay = week[week.length - 1];

  if (firstDay.isSame(lastDay, 'month')) return monthOfYear(firstDay);

  if (firstDay.isSame(lastDay, 'year'))
    return `${month(firstDay)} - ${monthOfYear(lastDay)}`;

  return `${monthOfYear(firstDay)} - ${monthOfYear(lastDay)}`;
}

function month(moment) {
  return capitalize(moment.format('MMMM'));
}

function monthOfYear(moment) {
  return `${capitalize(moment.format('MMMM'))} de ${moment.format('YYYY')}`;
}
